import React, { useState, useEffect } from "react";
import "./Footer.css";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube, FaArrowUp  } from "react-icons/fa";
import { Link } from "react-router-dom";
import FooterLogo from "../../assets/images/logo.png";

const Footer = () => {

const [showScroll, setShowScroll] = useState(false);

    // Show button when scroll down 300px
    useEffect(() => {
        const checkScrollTop = () => {
        if (!showScroll && window.scrollY > 300) {
            setShowScroll(true);
        } else if (showScroll && window.scrollY <= 300) {
            setShowScroll(false);
        }
        };
        window.addEventListener("scroll", checkScrollTop);
        return () => window.removeEventListener("scroll", checkScrollTop);
    }, [showScroll]);

    // Scroll to top smoothly
    const scrollTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-col policy">
          <img src={FooterLogo} alt="College Logo" className="footer-logo"/>
          {/* <h4>Anti-Ragging Policy</h4> */}
          <p>
            Vasavi College of Engineering complies with UGC, AICTE, and State
            Law to prohibit and prevent ragging on campus.
          </p>
          <p className="italic">"Ragging - A violation of Human Rights."</p>
          <p>
            9-5-81, Ibrahimbagh, Hyderabad - 500031 <br />
            <a href="mailto:principal@staff.vce.ac.in">
              principal@staff.vce.ac.in
            </a>
            <br />
            +91 40 23146003 <br />
            +91 40 23146090
          </p>
        </div>

        <div className="footer-col">
          <h4>Downloads</h4>
          <ul>
            <li>I.T. declaration form 2025-26</li>
            <li>Offline Certificate Requests</li>
            <li>Exam Fee Form</li>
            <li>Student No Dues Certificate</li>
            <li>Online Fee Payment - A/C Details</li>
            <li>Revaluation Application</li>
            <li>Photocopy Request Form</li>
            <li>Registration Forms (B.E / MCA / ME / M.Tech)</li>
            <li className="small">VCE GST No.: 36AAATV1119R1Z2</li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Useful Links</h4>
          <ul>
            <li>Osmania University</li>
            <li>AICTE</li>
            <li>UGC</li>
            <li>TS EAMCET</li>
            <li>Spoken Tutorials (IIT Bombay)</li>
            <li>NPTEL</li>
            <li>SWAYAM</li>
            <li>InfyTQ - Infosys</li>
            <li>National Career Service</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Vasavi College of Engineering | All Rights Reserved</p>
        <div className="social-icons">
          <Link href="#"><FaFacebookF /></Link>
          <Link href="#"><FaTwitter /></Link>
          <Link href="#"><FaLinkedinIn /></Link>
          <Link href="#"><FaYoutube /></Link>
        </div>
      </div>

            {/* === Scroll to Top Arrow === */}
                {showScroll && (
                    <button className="scroll-to-top" onClick={scrollTop}>
                    <FaArrowUp />
                    </button>
                )}

    </footer>
  );
};

export default Footer;
